import BaseAuthenticationModel from "scripts/models/baseAuthenticationModel";

class VerifyEmailNotificationModel extends BaseAuthenticationModel {
  url() {
    return `${this.authenticationUrlRoot}/notifications/verify_email`;
  }
}

export default VerifyEmailNotificationModel;
